var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBoxGrayLg = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 220,
  height: 178,
  fill: "none",
  viewBox: "0 0 220 178",
  ref: ref
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 110,
  cy: 88,
  r: 80,
  fill: "var(--utility-gray-200, black)"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 26,
  cy: 28,
  r: 8,
  fill: "var(--utility-gray-100, black)"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 198,
  cy: 134,
  r: 6,
  fill: "var(--utility-gray-100, black)"
})), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
  cx: 25,
  cy: 146,
  r: 10,
  fill: "var(--utility-gray-100, black)"
})), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
  cx: 210,
  cy: 54,
  r: 10,
  fill: "var(--utility-gray-100, black)"
})), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
  cx: 191,
  cy: 19,
  r: 7,
  fill: "var(--utility-gray-100, black)"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_dd_1182_2727)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "var(--utility-gray-200, black)",
  d: "m110 54.953 6.912-2.895-6.911 2.944v82.43l63.689-26.689V28.277l.31-.13-.31-.138v-.139l-.16.068L110.503 0 46 27.477l.305.13L46 109.74l64 27.643z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "var(--utility-gray-100, black)",
  d: "M110 54.953v82.43l-64-27.644.305-82.131zM110.001 55.002v82.43l63.689-26.689V27.871z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "var(--utility-gray-100, black)",
  d: "m110 54.953 64-26.806L110.503 0 46 27.477z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "var(--utility-gray-200, black)",
  d: "m70.126 17.2 63.756 27.75.579 20.223 17.838-7.36-.54-20.35-65.642-27.075z"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_b_1182_2727)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "var(--utility-gray-400, black)",
  d: "M82 132c0-15.464 12.536-28 28-28s28 12.536 28 28-12.536 28-28 28-28-12.536-28-28"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "var(--fg-white)",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M105.333 136.667 110 132m0 0 4.667 4.667M110 132v10.5m9.333-4.967a6.417 6.417 0 0 0-4.083-11.366.72.72 0 0 1-.623-.353 8.75 8.75 0 1 0-13.742 10.612"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgBoxGrayLg);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/BoxGrayLg.a765a0165d22b5f0a18075ca9f6cc277.svg";